import React, { useState } from 'react'
import { Carousel, Col, Container, Modal, Row } from 'react-bootstrap'
import { galleryList } from '../../data/localData'

function PlantGallery() {
    const [show, setShow] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const handleSelect = (selectedIndex, e) => {
        setActiveIndex(selectedIndex);
    };

    return (
        <div className='web-gallery-imglist'>
            <Container>
                <Row className='gy-4'>
                    {/* <Col className='col-12 col-md-8'> */}
                    <Col className='col-12 col-md-12'>
                        <Row className='gy-4'>
                            {
                                galleryList.map((image, index) => {
                                    return (
                                        // <Col key={index} className='col-6 col-md-4'>
                                        <Col key={index} className='col-6 col-md-4 col-xl-3'>
                                            <div className='img-holder' onClick={() => {
                                                setActiveIndex(index)
                                                setShow(true)
                                            }}>
                                                <img src={image} alt="" />
                                            </div>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </Col>
                    {/* <Col className='col-12 col-md-4'>

                    </Col> */}
                </Row>
            </Container>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body className='p-0'>
                    {/* <div className='w-100 overflow-hidden p-0 bg-dark' style={{
                        height: "90vh"
                    }}>
                        <img src={galleryList[activeIndex]} className='w-100 h-100 object-contain' alt="" />
                    </div> */}
                    <Carousel fade indicators={false} interval={null} activeIndex={activeIndex} className='main-holder' onSelect={handleSelect}>
                        {
                            galleryList.map((image, index) => {
                                return (
                                    <Carousel.Item key={index} className=''>
                                        <div className='w-100 overflow-hidden p-0 bg-dark' style={{
                                            height: "90vh"
                                        }}>
                                            <img src={image} className='w-100 h-100 object-contain' alt="" />
                                        </div>
                                    </Carousel.Item>
                                )
                            })
                        }
                    </Carousel>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PlantGallery